//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CheckPhone from '../_components/_check_phone'
import { sendCtmEvtLog } from '@/utils/log'
import { getFavouriteText } from '../utils'
import { handleImgSize } from '@/common/utils/map_view_data'
export default {
    components: {
        CheckPhone
    },
    computed: {
        favourite_icon () {
            const { favourite } = this.house
            if (this.is_vip) {
                return favourite ? '56_bell_action_vip' : '56_bell_normal'
            }
            return favourite ? '56_bell_action' : '56_bell_normal'
        },
        address_desc () {
            const { address, zone } = this.house
            return [address, zone].filter(v => v).join('-')
        },
        headimg () {
            const { house, show_vr } = this
            let url = house.photos_urls && house.photos_urls.length ? house.photos_urls[0] : ''
            if (show_vr) {
                url = house.vr_resource.vr_photo_url
            }
            return handleImgSize(url, 240, 176)
        },
        tag () {
            const { tag_list, status } = this.house
            return this.house.hide_status ?
                    tag_list && tag_list.length
                    ?
                    tag_list[0] : ''
                :
                (this.ln_status || status)
        },
        favourite_text () {
            const { favourite, status } = this.house
            return getFavouriteText(favourite, status)
        }
    },
    methods: {
        tapPhoto () {
            if (this.show_vr) {
                this.$emit('goVR')
            } else if (this.video_url) {
                this.$emit('goVideo')
            } else {
                this.$emit('goBuildingImg')
            }
        }
    },
    props: {
        ln_status: String,
        show_vr: {
            type: Boolean
        },
        video_url: {
            type: String
        },
        is_vip: {
            type: Boolean
        },
        house: {
            type: Object
        },
        zone_section: {
            type: String
        },
        open_type: {
            type: String
        }
    }
}
